import { PartnersLogoDarkIcon, PartnersLogoIcon } from "@partners/ui";
import { Link } from "@tanstack/react-router";

type HeaderLogoProps = {
  darkLogo?: boolean;
};

export const HeaderLogo = ({ darkLogo = false }: HeaderLogoProps) => (
  <Link key="partners-logo-link" to="/">
    <div className="pointer-events-none p-2">
      {darkLogo && (
        <PartnersLogoDarkIcon
          className="w-auto h-8 lg:h-10"
          title="Pepperstone partners logo dark"
        />
      )}
      {!darkLogo && (
        <PartnersLogoIcon
          className="w-auto h-8 lg:h-10"
          title="Pepperstone partners logo"
        />
      )}
    </div>
  </Link>
);
